// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"ce3b9a55","787":"e70024f0","850":"1f8c6d5c"}[chunkId] + ".chunk.js";
};